export default __webpack_public_path__ + "static/media/DocGif.c240c671.webm";